import { createContext, useContext } from "react";
import type { RentManagerUdfMapping } from "shared/types";

interface CredentialSaveContextValue {
  credentialId: number;
  integration: string;
  credentials: Record<string, string>;
  settings: Record<string, string | boolean | string[]>;
  // CRM-1069: surfaced at the credential payload top level, not inside settings.
  rentManagerUdfMappings?: RentManagerUdfMapping[];
  acceptingApplicationsMappingLocked?: boolean;
}

export const CredentialSaveContext =
  createContext<CredentialSaveContextValue | null>(null);

export const useCredentialSaveContext = () => useContext(CredentialSaveContext);
